import {Box, Grid, Slot as BaseSlot} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import {useAction} from '../../actions'
import {renderWidget} from '../index'
import type {SlotWidgetProps as Props} from '../types'
import * as styles from './Slot.classes'
import {SlotBody} from './SlotBody'

/**
 * Компонент слота.
 * Слот - бокс с текстовыми мини-блоками в середине и любыми компонентами в начале/конце блока.
 */
export const Slot: React.FC<Props> = props => {
  const {slot, className} = props.config
  const {lead, body1, body2, body3, trail1, trail2, action} = slot
  const {ActionComponent, triggerAction} = useAction(action)

  return (
    <BaseSlot className={className} onClick={triggerAction}>
      <Box alignItems="center" className={styles.box} justifyContent="space-between">
        {lead && renderWidget(lead)}
        <Grid
          className={clsx(
            styles.grid,
            {[styles.centeredText]: body1?.align === 'center'},
            {[styles.trailless]: !trail1 && !trail2},
          )}
          direction="row"
        >
          {body1 && <SlotBody body={body1} />}
          {body2 && <SlotBody body={body2} />}
          {body3 && <SlotBody body={body3} />}
        </Grid>
        <Box flexDirection="row" gap="s">
          {trail1 && renderWidget(trail1)}
          {trail2 && renderWidget(trail2)}
        </Box>
      </Box>
      {ActionComponent}
    </BaseSlot>
  )
}
